import * as React from 'react';
import { Box } from '@mui/material';
import { FINGER_NUMBERS_DISPLAYS } from 'Seeds/ExerciseContent/scaleFingering';
import { useSetting } from 'Settings/useSetting';
import { FINGER_NUMBERS_DISPLAY_LABELS } from './scaleFingerNumbersSettings';

/** Settings > Practice: show or hide the reference finger numbers on scale runs. */
const ScaleFingerNumbersControl = () => {
  // Read and written through the settings model (a global, per-user device setting).
  const [display, setDisplay] = useSetting('scaleFingerNumbers');

  return (
    <Box sx={{ marginBottom: '24px', fontFamily: 'Lato' }}>
      <Box
        id="scale-finger-numbers-label"
        sx={{
          fontStyle: 'normal',
          fontWeight: '400',
          fontSize: '16px',
          letterSpacing: '0.01em',
          color: '#ECECEC',
          marginBottom: '10px',
        }}
      >
        Finger numbers
      </Box>
      <Box
        role="radiogroup"
        aria-labelledby="scale-finger-numbers-label"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          gap: '10px',
          flexWrap: 'wrap',
        }}
      >
        {FINGER_NUMBERS_DISPLAYS.map((option) => {
          const selected = display === option;
          return (
            <Box
              key={option}
              component="button"
              type="button"
              role="radio"
              aria-checked={selected}
              onClick={() => setDisplay(option)}
              sx={{
                padding: '10px 14px',
                borderRadius: '999px',
                border: selected ? '1px solid #7FD7FF' : '1px solid rgba(255,255,255,0.18)',
                backgroundColor: selected ? 'rgba(127, 215, 255, 0.14)' : 'transparent',
                color: selected ? '#ECECEC' : '#9CA3AF',
                font: 'inherit',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
              }}
            >
              {FINGER_NUMBERS_DISPLAY_LABELS[option]}
            </Box>
          );
        })}
      </Box>
      <Box
        sx={{
          marginTop: '10px',
          fontSize: '13px',
          color: 'rgba(236,236,236,0.62)',
        }}
      >
        The reference fingering on scales in Exercises. Never graded.
      </Box>
    </Box>
  );
};

export default ScaleFingerNumbersControl;
